import React from "react";
import { createRoot } from "react-dom/client";
import "./Styles/theme.css";
import "./Styles/Main.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const rootElement = document.getElementById("root");
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// The production pages are prerendered from a browser snapshot for crawlers and
// no-JavaScript visitors. A snapshot can contain browser-normalized markup that
// is not byte-for-byte hydratable, so mount the interactive app as a client root.
// React replaces the prerendered children on its first commit.
createRoot(rootElement).render(app);

reportWebVitals();
